export default __webpack_public_path__ + "static/media/fire.0e95badd.png";